import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Clean up leaked text nodes from platform script injection
for (let n = document.body.firstChild; n; ) {
  const next = n.nextSibling;
  if (n.nodeType === 3 && n.textContent.trim()) n.remove();
  n = next;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
